<template>
  <Select placeholder="选择分组" v-model="Opts.selectIndex" v-if="Opts">
    <Option v-for="(item, index) in items" :key="index" :value="index">{{ item.text }}</Option>
  </Select>
</template>

<script>
export default {
  props: {
    Opts: Object
  },
  data() {
    return {
      items: this.Opts.items
    };
  },
  watch: {
    "Opts.selectIndex": function(newVal, oldVal) {
      var index = newVal;
      var value = this.Opts.items[index];
      this.$emit("on-set", index, value);
    }
  }
};
</script>


